import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { fuseAnimations } from '@fuse/animations';
import { FuseConfigService } from '@fuse/services/config.service';
import { AppConfigService } from 'app/providers/data/app-config.service';
import { LoginService } from 'app/providers/login.provider';
import { ResourcesProvider } from 'app/providers/resources.provider';
import { Observable } from 'rxjs';
import { confirmPasswordValidator } from '../register-2/register-2.component';

@Component({
  selector: 'app-adviser-citizen',
  templateUrl: './adviser-citizen.component.html',
  styleUrls: ['./adviser-citizen.component.scss'],
  animations   : fuseAnimations
})
export class AdviserCitizenComponent implements OnInit {

  registerForm: FormGroup;
  currentUser: any;
  termNotChecked: boolean = false;
  privacityNotChecked: boolean = false;
  notLengthPass: boolean = false;
  errorMsjRegister: string = '';
  isLoading: boolean = false;
  isAuthority: boolean = false;
  municipalities: any = [];
  nameList: any = [];
  filteredOptions: Observable<Array<any>>;


  constructor(
    private _fuseConfigService: FuseConfigService,
    private _formBuilder: FormBuilder,
    private _loginService: LoginService,
    private _resourceService: ResourcesProvider,
    private _settings: AppConfigService,
    private router: Router
  ) 
  { 
    // Configure the layout
    this._fuseConfigService.config = {
        layout: {
            navbar   : {
                hidden: true
            },
            toolbar  : {
                hidden: true
            },
            footer   : {
                hidden: true
            },
            sidepanel: {
                hidden: true
            }
        }
    };

    // this.currentUser = this._settings.getCurrentUser();
    // if(this.currentUser === undefined) {
    //   this.router.navigate(['pages/auth/login']);
    // }
  }

  ngOnInit(): void {
    this._getMunicipalities();
    this.registerForm = this.getRegisterForm();
  }

  getRegisterForm() {
    return this._formBuilder.group({
        //citi                 : [this.currentUser.ciud],
        name                 : ['', Validators.required],
        paterno              : ['', Validators.required],
        materno              : ['', Validators.required],
        email                : ['', Validators.required],
        telefono             : ['', Validators.required],
        muni                 : ['', Validators.required],
        dire                 : [''],
        desc                 : ['', Validators.required],
        auto                 : ['', Validators.required],
        docu                 : [''],
        empl                 : [''],
        
    });
  }

  onSubmit() {
      this.errorMsjRegister = '';
      this.isLoading = true;
      if (this.registerForm.valid) {
          this._loginService.registerAdviser(this.registerForm.value).subscribe(
              (res)=> {
                  this.isLoading = false;
                  this.router.navigate(['pages/auth/mail-confirm/assesory']);
              },
              (error) => {
                  this.isLoading = false;
                  this.errorMsjRegister = this._settings._getMsjError(error);
              }
          )
    }
  }

  onCancel() {
    sessionStorage.clear();
    this.router.navigate(['/']);
  }

  _getMunicipalities() {
    this._resourceService.getMunicipalities().subscribe(
        (result) => this.municipalities = result['data'],
        (error) => console.log('error get municipalities')
    );
  }

  validTermsChecked = () => {
    this.termNotChecked = !this.registerForm.value.terms;
  }

  validPrivacityChecked = () => {
    this.privacityNotChecked = !this.registerForm.value.privacity;
  }

}


/**
 * 
 * auto: "autoridad de prueba"
citi: 1
crtd: ""
desc: "prueba 1 de descripcion de asesoría"
detd: null
dire: "paseo tollocan"
docu: "doc ine↵↵doc acta"
empl: 0
muni: 29
nume: 0
uptd: ""
 */